import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/pmsservice/api/houseStatus/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/houseStatus/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/houseStatus/info',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/houseStatus/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/houseStatus/updateStatus',
    method: 'post',
    data: data
  });
} // 仪表列表

export function fetchMeterList(data) {
  return request({
    url: '/pmsservice/api/houseStatus/meterList',
    method: 'post',
    data: data
  });
}
export function fetchHouseDetail(data) {
  return request({
    url: '/pmsservice/api/houseStatus/get',
    method: 'post',
    data: data
  });
}